export const ONTARIO_CITIES = [
  'Ajax', 'Amherstburg', 'Aurora', 'Aylmer', 'Barrie', 'Belleville', 'Bowmanville',
  'Bradford', 'Brampton', 'Brantford', 'Brockville', 'Burlington', 'Cambridge',
  'Caledon', 'Chatham', 'Clarington', 'Cobourg', 'Collingwood', 'Cornwall',
  'East Gwillimbury', 'Elliot Lake', 'Essex', 'Fort Erie', 'Georgina',
  'Gravenhurst', 'Greater Sudbury', 'Grimsby', 'Guelph', 'Halton Hills',
  'Hamilton', 'Huntsville', 'Ingersoll', 'Innisfil', 'Kawartha Lakes',
  'Kenora', 'Kingston', 'Kirkland Lake', 'Kitchener', 'Leamington',
  'Lincoln', 'London', 'Markham', 'Midland', 'Milton', 'Mississauga',
  'Napanee', 'Newmarket', 'Niagara Falls', 'Niagara-on-the-Lake', 'Norfolk County',
  'North Bay', 'Oakville', 'Orillia', 'Oshawa', 'Ottawa', 'Owen Sound',
  'Pelham', 'Pembroke', 'Penetanguishene', 'Peterborough', 'Petawawa',
  'Pickering', 'Port Colborne', 'Port Hope', 'Quinte West', 'Renfrew',
  'Richmond Hill', 'Sarnia', 'Sault Ste. Marie', 'Simcoe', 'St. Catharines',
  'St. Thomas', 'Stratford', 'Strathroy', 'Thorold', 'Thunder Bay',
  'Tillsonburg', 'Timmins', 'Toronto', 'Vaughan', 'Wasaga Beach',
  'Waterloo', 'Welland', 'Whitby', 'Windsor', 'Woodstock',
]
